import http from '@/httpCommon/axiosClient';

class Profile {
    get = async () => {
        const res: any = await http.get('admin-account/get/me');

        return res?.data;
    };
    edit = async (body: any) => {
        const res: any = await http.patch('admin-account/get/me', { ...body });

        return res?.data;
    };
    editPassword = async (body: any) => {
        const res: any = await http.patch('admin-account/edit-password/me', { ...body });

        return res?.data;
    };
}
export default new Profile();
